<template>
  <div>
    <div style="position: fixed;top: 0;right: 0;left: 0;">
      <div class="header">
        <div class="search">
          <img :src="searchimg" alt="">
          <input v-model="txtInput" type="text" placeholder="请输入投保人/产品名/车牌号">
        </div>
        <label @click="tapToSearch">搜索</label>
      </div>
      <div class="tabs">
        <ul>
          <li>
            <div class="tab_name" :class="{active:num==='00'}" @click="queryFn('00')">
              全部
            </div>
          </li>
          <li>
            <div class="tab_name" :class="{active:num==='01'}" @click="queryFn('01')">
              暂存
            </div>
          </li>
          <li>
            <div class="tab_name" :class="{active:num==='02'}" @click="queryFn('02')">
              待支付
            </div>
          </li>
          <li>
            <div class="tab_name" :class="{active:num==='03'}" @click="queryFn('03')">
              已支付
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 手续费都不要显示 全部 -->
    <div v-if="num==='00'" class="main_contain">
      <div v-for="(itemAll,index) in orderListAll" :key="index" class="card" @click="Next(itemAll)">
        <div class="title_area">
          <span v-if="itemAll.insuranceSign === '0' || itemAll.orderStatus==='0' || itemAll.orderStatus==='3'">{{ itemAll.licenseNo }}</span>
          <span v-else>{{ itemAll.insuredName }}</span>
          <label v-if="itemAll.orderStatus !== '4' && itemAll.orderStatus !== '5' && itemAll.orderStatus !== '6'">{{ itemAll.statusText }}</label>
        </div>
        <div class="content_area">
          <ul>
            <li v-if="itemAll.insuranceSign === '0' || itemAll.orderStatus==='0' || itemAll.orderStatus==='3'">
              <label style="width:25%">投保人:</label>{{ itemAll.insuredName }}
            </li>
            <li v-else>
              {{ itemAll.productName }}
            </li>
            <li><label style="width:25%">订单号:</label>{{ itemAll.orderNo }}</li>
            <li><label style="width:25%">订单时间:</label>{{ itemAll.orderTime }}</li>
            <li v-if="itemAll.orderStatus === '1'">
              <label style="width:25%">起保时间:</label>{{ itemAll.proposalStartDate }}
            </li>
            <li v-if="itemAll.orderStatus === '4' || itemAll.orderStatus === '5' || itemAll.orderStatus === '6'">
              <label style="width:25%">支付时间:</label>{{ itemAll.payTime }}
            </li>
            <li v-if="itemAll.orderStatus === '1' || itemAll.orderStatus === '3'" class="mark_area" @click.stop="opinion(itemAll.remarks)">
              <span>{{ itemAll.remarks }}</span>
              <van-icon name="arrow" color="rgb(102, 102, 102)" />
            </li>
            <li v-if="itemAll.orderStatus === '1' || itemAll.orderStatus === '2'">
              <label style="width:25%">保费:</label><span style="color:#f29600">¥{{ itemAll.orderAmount }}</span>
            </li>
            <li v-if="itemAll.orderStatus === '4' && itemAll.insuranceSign==='0'">
              <label style="width:25%">保费:</label><span style="color:#f29600">¥{{ itemAll.payFee }}</span>
            </li>
            <li v-if="itemAll.orderStatus === '4' && itemAll.insuranceSign==='1'">
              <label style="width:25%">保费:</label><span style="color:#f29600">¥{{ itemAll.orderAmount }}</span>
            </li>
          </ul>
          <div class="img_area">
            <img v-if="itemAll.orderStatus === '4'" :src="hadCDImg" alt="">
            <img v-else-if="itemAll.orderStatus === '6'" :src="hadTBImg" alt="">
            <img v-else-if="itemAll.orderStatus === '5'" :src="hadSXImg" alt="">
          </div>
        </div>
        <div v-if="itemAll.orderStatus !== '4' && itemAll.orderStatus !== '6'" class="btn_area">
          <button v-if="itemAll.orderStatus === '2'" @click.stop="withdraw(itemAll.orderNo)">
            注销
          </button>
          <button v-if="itemAll.orderStatus === '0'||itemAll.orderStatus === '3'||itemAll.orderStatus === '5'" @click.stop="remove(itemAll.id)">
            删除
          </button>
          <button v-if="itemAll.orderStatus === '0'">
            继续录入
          </button>
          <button v-if="itemAll.orderStatus === '3'" @click.stop="Next(itemAll)">
            修改
          </button>
          <button v-if="itemAll.orderStatus === '2' && itemAll.insuranceSign === '0'" @click.stop="modify(itemAll.orderNo)">
            修改
          </button>
          <button v-if="itemAll.orderStatus === '5' && itemAll.insuranceSign === '0'" @click.stop="copyOrder(itemAll.id)">
            修改
          </button>
          <button v-if="itemAll.orderStatus === '1'" @click.stop="cancel(itemAll.orderNo)">
            撤销
          </button>
          <button v-if="itemAll.orderStatus === '2'" @click.stop="goPay(itemAll)">
            支付
          </button>
        </div>
      </div>
    </div>
    <!-- 暂存 -->
    <div v-if="num==='01'" class="main_contain">
      <div v-for="(itemZC,index) in orderListZC" :key="index" class="card" @click="Next(itemZC)">
        <div class="title_area">
          <span>{{ itemZC.licenseNo }}</span>
          <label>{{ itemZC.statusText }}</label>
        </div>
        <div class="content_area">
          <ul>
            <li><label>投保人:</label>{{ itemZC.insuredName }}</li>
            <li><label>订单号:</label>{{ itemZC.orderNo }}</li>
            <li><label>订单时间:</label>{{ itemZC.orderTime }}</li>
            <li v-if="itemZC.orderStatus === '3'" class="mark_area">
              <span>{{ itemZC.remarks }}</span>
              <van-icon name="arrow" color="rgb(102, 102, 102)" />
            </li>
          </ul>
        </div>
        <div class="btn_area">
          <button @click.stop="remove(itemZC.id)">
            删除
          </button>
          <button v-if="itemZC.orderStatus === '0'">
            继续录入
          </button>
          <button v-if="itemZC.orderStatus === '3'" @click.stop="Next(itemZC)">
            修改
          </button>
        </div>
      </div>
    </div>
    <!-- 待支付 -->
    <div v-if="num==='02'" class="main_contain">
      <div v-for="(itemDZF,index) in orderListDZF" :key="index" class="card" @click="Next(itemDZF)">
        <div class="title_area">
          <span v-if="itemDZF.insuranceSign === '0'">{{ itemDZF.licenseNo }}</span>
          <span v-else>{{ itemDZF.insuredName }}</span>
          <label>{{ itemDZF.statusText }}</label>
        </div>
        <div class="content_area">
          <ul>
            <li v-if="itemDZF.insuranceSign === '0'">
              <label>投保人:</label>{{ itemDZF.insuredName }}
            </li>
            <li v-else>
              {{ itemDZF.productName }}
            </li>
            <li><label>订单号:</label>{{ itemDZF.orderNo }}</li>
            <li><label>订单时间:</label>{{ itemDZF.orderTime }}</li>
            <li v-if="itemDZF.orderStatus === '1'">
              <label>起保时间:</label>{{ itemDZF.proposalStartDate }}
            </li>
            <li v-if="itemDZF.orderStatus === '1'" class="mark_area" @click.stop="opinion(itemDZF.remarks)">
              <span>{{ itemDZF.remarks }}</span>
              <van-icon name="arrow" color="rgb(102, 102, 102)" />
            </li>
            <li><label>保费:</label><span style="color:#f29600">¥{{ itemDZF.orderAmount }}</span></li>
          </ul>
        </div>
        <div class="btn_area">
          <!-- 待支付且为非车，有修改和注销
            待支付且为车险，无修改有注销
            核保中只有撤销 -->
          <button v-if="itemDZF.orderStatus === '2'" @click.stop="withdraw(itemDZF.orderNo)">
            注销
          </button>
          <button v-if="itemDZF.orderStatus === '2' && itemDZF.insuranceSign === '0'" @click.stop="modify(itemDZF.orderNo)">
            修改
          </button>
          <button v-if="itemDZF.orderStatus === '2'" @click.stop="goPay(itemDZF)">
            支付
          </button>
          <button v-if="itemDZF.orderStatus === '1'" @click.stop="cancel(itemDZF.orderNo)">
            撤销
          </button>
        </div>
      </div>
    </div>
    <!-- 已支付 -->
    <div v-if="num==='03'" class="main_contain">
      <div v-for="(itemYZF,index) in orderListYZF" :key="index" class="card" @click="Next(itemYZF)">
        <div class="title_area">
          <span v-if="itemYZF.insuranceSign === '0'">{{ itemYZF.licenseNo }}</span>
          <span v-else>{{ itemYZF.insuredName }}</span>
        </div>
        <div class="content_area">
          <ul>
            <li v-if="itemYZF.insuranceSign === '0'">
              <label style="width:25%">投保人:</label>{{ itemYZF.insuredName }}
            </li>
            <li v-else>
              {{ itemYZF.productName }}
            </li>
            <li><label style="width:25%">订单号:</label>{{ itemYZF.orderNo }}</li>
            <li><label style="width:25%">订单时间:</label>{{ itemYZF.orderTime }}</li>
            <li><label style="width:25%">支付时间:</label>{{ itemYZF.payTime }}</li>
            <li v-if="itemYZF.insuranceSign === '1'">
              <label style="width:25%">保费:</label><span style="color:#f29600">¥{{ itemYZF.orderAmount }}</span>
            </li>
            <li v-if="itemYZF.insuranceSign === '0'">
              <label style="width:25%">保费:</label><span style="color:#f29600">¥{{ itemYZF.payFee }}</span>
            </li>
          </ul>
          <div class="img_area">
            <img v-if="itemYZF.orderStatus === '4'" :src="hadCDImg" alt="">
            <img v-else-if="itemYZF.orderStatus === '6'" :src="hadTBImg" alt="">
            <img v-else-if="itemYZF.orderStatus === '5'" :src="hadSXImg" alt="">
          </div>
        </div>
      </div>
    </div>
    <div v-show="noDataTip" class="no_data">
      <img :src="noDataImg" alt="">
      <p>我的订单空空如也哦</p>
    </div>
    <van-popup v-model="showMoreVis" style="border-radius: 0.08rem;">
      <div style="font-size: 0.14rem;padding: 0.15rem;width:2.8rem;">
        修改意见：{{ opinionValue }}
      </div>
    </van-popup>
    <Loading :switchs="switchs" />
  </div>
</template>

<script>
import api from '@/api/api.js'
import { Dialog, Toast, Icon } from 'vant'
import Loading from '@/components/Loadings/Loading'
import checkFormat from '@/utils/checkFormat.js'
export default {
  components: {
    'van-icon': Icon,
    'Loading': Loading
  },
  data() {
    return {
      switchs: false,
      num: '00', // tab
      searchimg: api.imgAllUrl + '/search0710.png',
      succeedimg: api.imgAllUrl + '/Group20710.png',
      succeedUrl: api.imgAllUrl + '/Group0710.png',
      noDataImg: api.imgAllUrl + '/sales440723.png',
      hideMoneyImg: api.imgAllUrlZSB + '/HiddenState20191101.png',
      hadCDImg: api.imgAllUrlZSB + '/Group.png',
      hadTBImg: api.imgAllUrlZSB + '/Surrender20191024.png',
      hadSXImg: api.imgAllUrlZSB + '/Group2.png',
      orderListAll: [], // 全部数据
      pageNumberAll: 0, // 全部页码
      pageCountAll: 0, // 全部总页数
      orderListZC: [], // 暂存数据
      pageNumberZC: 0, // 暂存页码
      pageCountZC: 0, // 暂存总页数
      orderListDZF: [], // 待支付数据
      pageNumberDZF: 0, // 待支付页码
      pageCountDZF: 0, // 待支付总页数
      orderListYZF: [], // 已支付数据
      pageNumberYZF: 0, // 已支付页码
      pageCountYZF: 0, // 待支付总页数
      // orderCategory: '', // 订单类别（00全部、01待提交、02待支付、03已支付）
      // orderStatus: '', // 订单状态(0暂存；1核保中；2待支付；3下发修改；4生效；5失效；6退保)
      loading: false, // 下拉加载
      total: null, // 总数
      txtInput: '', // 模糊查询条件
      noDataTip: false, // 当前无数据提示
      showMoreVis: false,
      opinionValue: '', // 意见
      isTrue: false,
      terminalId: '',
      channelCode: ''
    }
  },
  created() {
    const terminalId = checkFormat.getUrlKey('terminalId')
    if (!checkFormat.isEmpty(terminalId)) {
      this.terminalId = terminalId
    }
    const channelCode = checkFormat.getUrlKey('channelCode')
    if (!checkFormat.isEmpty(channelCode)) {
      this.channelCode = channelCode
    }
    document.title = '我的订单'
    // this.$route.query.channel
    console.log('this.$route.params', this.$route.query)
    if (this.$route.query.switchTab === '02') {
      this.num = '02'
    }
    if (this.$store.state.orderTabNum !== '') {
      this.num = this.$store.state.orderTabNum
    }
    this.$store.commit('setOrderId', '')
    this.$store.commit('setTab', '0')
    this.pageNumberAll = 0
    this.orderLists = []
    this.orderList = []
    this.getList(this.pageNumberAll, '00') // 调用订单列表接口未出单
  },
  destroyed() {
    this.$store.commit('setOrderTabNum', this.num)
    Toast.clear()
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll) // 翻页监听
  },
  methods: {
    // 切换tab查询列表
    queryFn(val) {
      this.num = val
      if (this.num === '00') {
        this.pageNumberAll = 0
        this.orderListAll = []
        this.getList(this.pageNumberAll)
      } else if (this.num === '01') {
        this.pageNumberZC = 0
        this.orderListZC = []
        this.getList(this.pageNumberZC)
      } else if (this.num === '02') {
        this.pageNumberDZF = 0
        this.orderListDZF = []
        this.getList(this.pageNumberDZF)
      } else if (this.num === '03') {
        this.pageNumberYZF = 0
        this.orderListYZF = []
        this.getList(this.pageNumberYZF)
      }
    },
    // 搜索
    tapToSearch() {
      if (this.num === '00') {
        this.pageNumberAll = 0
        this.orderListAll = []
        this.getList(this.pageNumberAll)
      } else if (this.num === '01') {
        this.pageNumberZC = 0
        this.orderListZC = []
        this.getList(this.pageNumberZC)
      } else if (this.num === '02') {
        this.pageNumberDZF = 0
        this.orderListDZF = []
        this.getList(this.pageNumberDZF)
      } else if (this.num === '03') {
        this.pageNumberYZF = 0
        this.orderListYZF = []
        this.getList(this.pageNumberYZF)
      }
    },
    // 加载新的页面
    handleScroll() {
      // 真实内容的高度
      var pageHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight)
      // 视窗的高度
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0
      // 隐藏的高度
      var scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      if (pageHeight - viewportHeight - scrollHeight < 10) { // 当滑动接近底部时触发事件
        if (this.num === '00') {
          if (this.orderListAll.length < this.total && this.pageNumberAll < this.pageCountAll) {
            if (this.isTrue) {
              this.pageNumberAll++
              this.getList(this.pageNumberAll)
              this.isTrue = false
            }
          }
        } else if (this.num === '01') {
          if (this.orderListZC.length < this.total && this.pageNumberZC < this.pageCountZC) {
            if (this.isTrue) {
              this.pageNumberZC++
              this.getList(this.pageNumberZC)
              this.isTrue = false
            }
          }
        } else if (this.num === '02') {
          if (this.orderListDZF.length < this.total && this.pageNumberDZF < this.pageCountDZF) {
            if (this.isTrue) {
              this.pageNumberDZF++
              this.getList(this.pageNumberDZF)
              this.isTrue = false
            }
          }
        } else if (this.num === '03') {
          if (this.orderListYZF.length < this.total && this.pageNumberYZF < this.pageCountYZF) {
            if (this.isTrue) {
              this.pageNumberYZF++
              this.getList(this.pageNumberYZF)
              this.isTrue = false
            }
          }
        }
      }
    },
    // 获取订单信息
    getList(pageNum) {
      let data = ''
      this.switchs = true
      this.loading = true
      const obj = JSON.parse(localStorage.getItem('setPersonUserInfo'))
      if (!checkFormat.isEmpty(obj)) {
        if ((obj.userCode !== undefined && obj.userCode !== '' && obj.userCode !== null) || (obj.userType !== undefined && obj.userType !== '' && obj.userType !== null)) {
          data = {
            condition: this.txtInput,
            terminalId: 'H5',
            orderOrigin: this.$route.query.channelCode,
            orderQueryStatus: this.num, // 订单状态(00全部、01暂存、02待支付、03已支付)
            pageNo: pageNum,
            pageSize: 5
          }
        }
      } else {
        data = {
          condition: this.txtInput,
          terminalId: this.terminalId || localStorage.getItem('setTerminalId'),
          orderOrigin: this.channelCode || localStorage.getItem('setChannelCode'),
          orderQueryStatus: this.num, // 订单状态(00全部、01暂存、02待支付、03已支付)
          pageNo: pageNum,
          pageSize: 5
        }
      }
      this.$http.post(api.orderqueryOrderList, data)
        .then(res => {
          this.loading = false
          const dataMessage = res.data.content
          this.total = res.data.totalCount
          this.noDataTip = dataMessage.length === 0
          for (const k in dataMessage) {
            const numOrderStatus = Number(dataMessage[k].orderStatus)
            switch (numOrderStatus) {
              case 0:
                dataMessage[k].statusText = '暂存'
                break
              case 1:
                dataMessage[k].statusText = '核保中'
                break
              case 2:
                dataMessage[k].statusText = '待支付'
                break
              case 3:
                dataMessage[k].statusText = '下发修改'
                break
              case 4:
                dataMessage[k].statusText = '生效'
                break
              case 5:
                dataMessage[k].statusText = '失效'
                break
              case 6:
                dataMessage[k].statusText = '退保'
                break
            }
            if (this.num === '00') {
              this.pageCountAll = res.data.pages
              this.orderListAll.push(dataMessage[k])
              this.isTrue = true
            } else if (this.num === '01') {
              this.pageCountZC = res.data.pages
              this.orderListZC.push(dataMessage[k])
              this.isTrue = true
            } else if (this.num === '02') {
              this.pageCountDZF = res.data.pages
              this.orderListDZF.push(dataMessage[k])
              this.isTrue = true
            } else if (this.num === '03') {
              this.pageCountYZF = res.data.pages
              this.orderListYZF.push(dataMessage[k])
              this.isTrue = true
            }
          }
          this.switchs = false
        })
        .catch(error => {
          this.switchs = false
          this.noDataTip = true
        })
    },
    // 展示更多
    opinion(item) {
      this.showMoreVis = true
      this.opinionValue = item
    },
    // 删除
    remove(id) {
      Dialog.confirm({
        message: '确定删除此订单吗？'
      }).then(() => {
        this.switchs = true
        const obj = {
          orderId: id, // 订单id
          deletedFlag: 'Y'
        }
        this.$http.post(api.deleteOrder, obj)
          .then(res => {
            Toast.clear()
            if (res.data.rtnCode === '0000') {
              if (this.num === '00') {
                this.orderListAll = []
                this.getList(this.pageNumberAll)
              } else if (this.num === '01') {
                this.orderListZC = []
                this.getList(this.pageNumberZC)
              }
            } else {
              Toast.fail(res.data.rtnMsg)
            }
          })
          .catch(err => {
            this.switchs = false
            console.log(err)
          })
      }).catch(() => {
        this.switchs = false
      })
    },
    // 注销
    withdraw(orderNo) {
      Dialog.confirm({
        message: '确定注销此订单吗？'
      }).then(() => {
        this.switchs = true
        const obj = {
          orderNo: orderNo
        }
        this.$http.post(api.withdrawOrder, obj)
          .then(res => {
            Toast.clear()
            if (res.data.rtnCode === '0000') {
              if (this.num === '00') {
                this.orderListAll = []
                this.getList(this.pageNumberAll)
              } else if (this.num === '02') {
                this.orderListDZF = []
                this.getList(this.pageNumberDZF)
              }
            } else {
              Toast.fail(res.data.rtnMsg)
            }
          })
          .catch(err => {
            this.switchs = false
            console.log(err)
          })
      }).catch(() => {
        this.switchs = false
      })
    },
    // 撤销
    cancel(orderNo) {
      Dialog.confirm({
        message: '确定撤销此订单吗？'
      }).then(() => {
        this.switchs = true
        const obj = {
          orderNo: orderNo
        }
        this.$http.post(api.cancelOrder, obj)
          .then(res => {
            Toast.clear()
            if (res.data.rtnCode === '0000') {
              if (this.num === '00') {
                this.orderListAll = []
                this.getList(this.pageNumberAll)
              } else if (this.num === '02') {
                this.orderListDZF = []
                this.getList(this.pageNumberDZF)
              }
            } else {
              Toast.fail(res.data.rtnMsg)
            }
          })
          .catch(err => {
            this.switchs = false
            console.log(err)
          })
      }).catch(() => {
        this.switchs = false
      })
    },
    // 已失效订单修改
    copyOrder(id) {
      this.switchs = true
      const obj = {
        orderId: id
      }
      this.$http.post(api.copyOrder, obj)
        .then(res => {
          this.switchs = false
          if (res.data.rtnCode === '0000') {
            this.$router.push({ name: 'Vehicle', query: { orderId: res.data.data.orderId, terminalId: this.$route.query.terminalId, channelCode: this.$route.query.channelCode }})
          } else {
            Toast.fail(res.data.rtnMsg)
          }
        })
        .catch(error => {
          this.switchs = false
          console.log(error)
        })
    },
    // 待支付的车险修改
    modify(orderNo) {
      Dialog.confirm({
        message: '当前订单是否需要注销修改'
      }).then(() => {
        this.switchs = true
        const obj = {
          orderNo: orderNo
        }
        this.$http.post(api.waitPayCancel, obj)
          .then(res => {
            this.switchs = false
            if (res.data.rtnCode === '0000') {
              this.$router.push({ name: 'Vehicle', query: { orderId: res.data.orderId, terminalId: this.$route.query.terminalId, channelCode: this.$route.query.channelCode }})
            } else {
              Toast.fail(res.data.rtnMsg)
            }
          })
          .catch(error => {
            this.switchs = false
            console.log(error)
          })
      }).catch(() => {
        this.switchs = false
      })
    },
    // 详情跳转
    Next(item) {
      console.log('ttttt', this.$route.query.channelCode)
      const obj = JSON.parse(localStorage.getItem('setPersonUserInfo'))
      // (0暂存；1核保中；2待支付；3下发修改；4生效；5失效；6退保)
      if (item.orderStatus === '1' || item.orderStatus === '2' || item.orderStatus === '4' || item.orderStatus == '5' || item.orderStatus == '6') {
        if (item.insuranceSign === '0') {
          this.$router.push({ name: 'Confirm', query: { orderId: item.id, terminalId: this.$route.query.terminalId, channelCode: this.$route.query.channelCode }})// 跳支付页
        } else {
          if (!checkFormat.isEmpty(obj)) {
            if ((obj.userCode !== undefined && obj.userCode !== '' && obj.userCode !== null) || (obj.userType !== undefined && obj.userType !== '' && obj.userType !== null)) {
              if (this.$route.query.isWho === 'market') {
                location.href = api.projectHostUrl + '/app/b2c/#/VerificationPage?orderId=' + item.id + '&orderNo=' + item.orderNo + '&productCode=' + item.productCode + '&channelCode=' + this.$route.query.channelCode + '&terminaId=' + this.$route.query.terminaId + '&showSharePay=1'
              } else {
                location.href = api.projectHostUrl + '/app/b2c/#/VerificationPage?orderId=' + item.id + '&orderNo=' + item.orderNo + '&productCode=' + item.productCode + '&channelCode=' + this.$route.query.channelCode + '&terminaId=' + this.$route.query.terminaId
              }
            }
          } else {
            location.href = api.projectHostUrl + '/app/b2c/#/VerificationPage?orderId=' + item.id + '&orderNo=' + item.orderNo + '&productCode=' + item.productCode + '&channelCode=' + this.$route.query.channelCode + '&terminaId=' + this.$route.query.terminaId
          }
        }
      } else if (item.orderStatus === '0' || item.orderStatus === '3') {
        this.$router.push({ name: 'Vehicle', query: { orderId: item.id, terminalId: this.$route.query.terminalId, channelCode: this.$route.query.channelCode }})// 暂存,下发修改跳车辆信息页
      }
    },
    // 去支付
    goPay(value) {
      if (value.insuranceSign === '1') {
        console.log('devUrl', api.devUrl, api.projectHostUrl, process.env.API_HOST)
        window.location.href = api.projectHostUrl + '/app/b2c/#/VerificationPage?orderId=' + value.id + '&orderNo=' + value.orderNo + '&productCode=' + value.productCode + '&magicId=1&channelCode=' + this.$route.query.channelCode + '&terminaId=' + this.$route.query.terminaId
        // if (this.devUrl === 'https://uat-open.zking.com') {
        //   // window.location.href='https://uat-open.zking.com/app/b2c/#/VerificationPage?orderId='+value.id+'&orderNo='+value.orderNo+'&productCode='+value.productCode+'&magicId=1&channelCode='+this.$route.query.channelCode
        // } else if (this.devUrl === 'https://open.zking.com') {
        //   // window.location.href='https://open.zking.com/app/b2c/#/VerificationPage?orderId='+value.id+'&orderNo='+value.orderNo+'&productCode='+value.productCode+'&magicId=1&channelCode='+this.$route.query.channelCode
        // } else {
        //   // window.location.href='https://test-open.zking.com/app/b2c/#/VerificationPage?orderId='+value.id+'&orderNo='+value.orderNo+'&productCode='+value.productCode+'&magicId=1&channelCode='+this.$route.query.channelCode
        // }
      } else {
        this.$router.push({ name: 'Confirm', query: { orderId: value.id, terminalId: this.$route.query.terminalId, channelCode: this.$route.query.channelCode }})// 跳支付页
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "./Order.scss"
</style>



// WEBPACK FOOTER //
// src/pages/Order/Order.vue